module.exports = __webpack_public_path__ + "img/elm-telecom.e2263336.png";